export const isInterlinkingEnabled = (toggles) => toggles?.isInterlinkingEnabled || false;
